import type { SVGProps } from "react";

export function LibraryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.012 7.26C3.70534 7.43482 3.45027 7.6875 3.27258 7.9925C3.09488 8.2975 3.00085 8.64401 3 8.997V18.997C3 20.097 3.9 20.997 5 20.997H15C15.75 20.997 16.158 20.612 16.5 19.997M11 7H16M11 10H17M11 13H14M7 5.667C7 4.95967 7.28099 4.28131 7.78115 3.78115C8.28131 3.28099 8.95967 3 9.667 3H18.333C18.6832 3 19.03 3.06898 19.3536 3.20301C19.6772 3.33704 19.9712 3.53349 20.2189 3.78115C20.4665 4.0288 20.663 4.32281 20.797 4.64638C20.931 4.96996 21 5.31676 21 5.667V14.333C21 14.6832 20.931 15.03 20.797 15.3536C20.663 15.6772 20.4665 15.9712 20.2189 16.2189C19.9712 16.4665 19.6772 16.663 19.3536 16.797C19.03 16.931 18.6832 17 18.333 17H9.667C8.95967 17 8.28131 16.719 7.78115 16.2189C7.28099 15.7187 7 15.0403 7 14.333V5.667Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LibraryShareIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.012 7.26C3.70534 7.43482 3.45027 7.6875 3.27258 7.9925C3.09488 8.2975 3.00085 8.64401 3 8.997V18.997C3 20.097 3.9 20.997 5 20.997H12M11 7H16M11 10H17M11 13H14M21 13V5.667C21 5.31676 20.931 4.96996 20.797 4.64638C20.663 4.32281 20.4665 4.0288 20.2189 3.78115C19.9712 3.53349 19.6772 3.33704 19.3536 3.20301C19.03 3.06898 18.6832 3 18.333 3H9.667C8.95967 3 8.28131 3.28099 7.78115 3.78115C7.28099 4.28131 7 4.95967 7 5.667V14.333C7 15.0403 7.28099 15.7187 7.78115 16.2189C8.28131 16.719 8.95967 17 9.667 17H14M16 22L21 17M21 17V21.5M21 17H16.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LibraryFillIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 5.13318C21.6347 5.21093 21.7494 5.31903 21.8349 5.44888C21.9205 5.57873 21.9746 5.72675 21.993 5.88118L22 5.99918V18.9992C22 19.1747 21.9538 19.3472 21.866 19.4992C21.7782 19.6512 21.652 19.7774 21.5 19.8652C21.348 19.9529 21.1755 19.9992 21 19.9992C20.8245 19.9991 20.652 19.9529 20.5 19.8652C19.3669 19.2109 18.0907 18.8445 16.7831 18.7982C15.4756 18.7518 14.1766 19.0268 13 19.5992V4.42518C14.3814 3.90918 15.8598 3.70508 17.3293 3.82748C18.7988 3.94988 20.223 4.39576 21.5 5.13318ZM11 4.42618L11.001 19.6002C9.8708 19.05 8.62686 18.7739 7.37002 18.7942C6.11318 18.8145 4.87881 19.1307 3.767 19.7172L3.44 19.8972L3.337 19.9412L3.288 19.9572L3.178 19.9832L3.117 19.9932L3 19.9992H2.958L2.848 19.9872L2.771 19.9732L2.663 19.9412L2.537 19.8852L2.442 19.8292L2.353 19.7622L2.293 19.7062L2.22 19.6242L2.156 19.5352L2.134 19.4992L2.102 19.4392L2.058 19.3362L2.042 19.2872L2.016 19.1772L2.006 19.1162L2.002 19.0672L2 5.99918C2 5.82364 2.04621 5.6512 2.13398 5.49919C2.22175 5.34718 2.34798 5.22094 2.5 5.13318C3.77705 4.39592 5.20134 3.95022 6.67084 3.82799C8.14035 3.70576 9.6187 3.91003 11 4.42618Z"
        fill="currentColor"
      />
    </svg>
  );
}
